import { render, staticRenderFns } from "./mc-gregor.vue?vue&type=template&id=01f0ce58&scoped=true&"
import script from "./mc-gregor.vue?vue&type=script&lang=js&"
export * from "./mc-gregor.vue?vue&type=script&lang=js&"
import style0 from "./mc-gregor.vue?vue&type=style&index=0&id=01f0ce58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f0ce58",
  null
  
)

export default component.exports